/**
 * @fileoverview CardHeader component
 * Displays the header section of a deal card with customer name and dealer name
 * Includes a clickable customer name action that opens the deal
 * Part of the RecentDealCard dumb component hierarchy
 */

import { Action } from '@interstate/components/Action';
import { DealerName, StyledCardHeader } from './CardHeader.style';
import type { CardHeaderProps } from '../../types';

const CardHeader: React.FC<CardHeaderProps> = ({ customerName, dealerName, onTitleClick }) => (
    <StyledCardHeader data-testid="card-header">
        <Action data-testid="customer-name-action" onClick={onTitleClick}>
            {customerName}
        </Action>
        <DealerName data-testid="dealer-name">{dealerName}</DealerName>
    </StyledCardHeader>
);

export default CardHeader;
